import { UserCoverStyle } from "@authory-packages/core";
import * as Yup from "yup";

// These validators are common across content type imports (PDF, Article, etc)
export const YupNameValidation = Yup.string().when("newSource", ([newSource], schema) =>
    newSource ? schema.required("Name is required").max(50, "Name too long (50 characters max)") : schema
);

export const YupDateValidation = Yup.date().required("Start date is required").typeError("Please enter a valid date");

export const YupSourceValidation = Yup.string().when("newSource", ([newSource], schema) =>
    newSource ? schema : schema.required("Please select a source")
);

export const REGEX_HEX = /^#?([a-f0-9]{6}|[a-f0-9]{3})$/;

export const ColorHexValidation = Yup.string()
    .nullable()
    .when("style", ([style], schema) =>
        style === UserCoverStyle.color ? schema.trim().lowercase().ensure().matches(REGEX_HEX, { message: "Please enter a valid hex" }) : schema
    );

export const ColorHexCustomizeValidation = Yup.string().trim().lowercase().ensure().matches(REGEX_HEX, { message: "Please enter a valid hex" });
